module.exports = __webpack_public_path__ + "img/Mayanei_Hayeshua_Mc.94ffd091.svg";